import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { PublisherService } from '../../../../../../services/publisher.service';
import { Helpers } from '../../../../../../helpers';
import { BaseComponent } from '../../../base.component';
import { Publisher } from '../../../../../../models/publisher';

@Component({
    selector: 'app-create-publisher',
    templateUrl: './create-publisher.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CreatePublisherComponent extends BaseComponent implements OnInit {
    publisher: Publisher = new Publisher();

    constructor(
        private publisherService: PublisherService,
        private router: Router
    ) {
        super();
    }

    ngOnInit() {
        this.initPhoneMasks();
    }

    initPhoneMasks() {
        (<any>$('#phone')).inputmask({
            mask: '(999) 999 9999'
        });
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                name: customRules.requiredText
            }
        });
    }

    createPublisher() {
        var _self = this;
        Helpers.setLoading(true);
        this.publisher.phone = (<any>$('#phone')).val();
        this.publisherService.create(this.publisher).subscribe(res => {
            Helpers.setLoading(false);
            this.swalService.successCreate();
            this.publisher.name = '';
            setTimeout(function() {
                _self.router.navigate(['/owner/publisher/list']);
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/owner/publishers/create-publisher/create-publisher.component.ts